import { PatientModal } from "../../../../../components";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "../../../../../hooks/use-disclosure";
import PlusIcon from "../../../../../components/icons/Plus";

interface IActionFormPatient {
  refetch: () => void;
}

const ActionFormPatient = ({ refetch }: IActionFormPatient) => {
  const { t } = useTranslation();
  const { onClose, isOpen, onOpen } = useDisclosure();

  return (
    <>
      <PatientModal
        visible={isOpen}
        onSubmit={() => {
          if (refetch) refetch();
        }}
        showNotification={false}
        onClose={onClose}
        title={t("common.text.completeYourProfile")}
      />

      <div className="primary-btn-outline" onClick={onOpen}>
        <PlusIcon />
        {t("common.button.addPatient")}
      </div>
    </>
  );
};

export default ActionFormPatient;
